import {
  Box,
  Button,
  ButtonGroup,
  Modal as MetModal,
  ModalProps,
  TextHeading,
} from '@ally/metronome-ui';
import { createRef, ReactNode } from 'react';
import styled from 'styled-components';
import { muiAllyTheme } from '../../../utils';

const StyledButton = styled(Button)`
  border: 0;
  &:hover {
    box-shadow: none;
    background-color: transparent;
  }
`;

interface IHeadingProps {
  color?: string;
  fontSize?: string;
  fontWeight?: 'bold' | 'normal';
}

type IProps = ModalProps &
  IHeadingProps & {
    heading: string;
    headingProps?: IHeadingProps;
    content?: ReactNode;
    continue?: (
      e: React.MouseEvent<HTMLButtonElement, globalThis.MouseEvent>
    ) => void;
    cancel?: (
      e: React.MouseEvent<HTMLButtonElement, globalThis.MouseEvent>
    ) => void;
    actions?: ReactNode;
  };

const StyledTextHeading = styled(TextHeading)`
  ${(props: IHeadingProps): string => `
    color: ${props?.color || muiAllyTheme.colors['gray-800']};
    font-size: ${props?.fontSize || 'inherit'};
  `}
`;

const Modal: React.FC<IProps> = (props: IProps) => {
  const modalRef = createRef<HTMLHeadingElement>();

  const {
    heading,
    headingProps,
    continue: continueAction,
    cancel,
    actions,
    content,
    color,
    fontSize,
    fontWeight,
    ...modalProps
  } = props;

  return (
    <MetModal
      {...(modalProps as ModalProps)}
      content={
        <>
          {heading && (
            <StyledTextHeading
              {...headingProps}
              ref={modalRef}
              tabIndex={-1}
              size='xs'
              weight={headingProps?.fontWeight || 'bold'}
            >
              {heading}
            </StyledTextHeading>
          )}
          <Box paddingTop='10px'>{content}</Box>
          {(continueAction || cancel) && (
            <Box paddingTop='30px'>
              <ButtonGroup buttonSize='sm'>
                {continueAction && (
                  <Button text='Continue' onClick={continueAction} />
                )}
                {cancel && (
                  <StyledButton
                    variant='outline'
                    text='Go Back'
                    onClick={cancel}
                  />
                )}
              </ButtonGroup>
            </Box>
          )}
          {actions && <Box paddingTop='30px'>{actions}</Box>}
        </>
      }
    />
  );
};

export default Modal;
